// extracted by mini-css-extract-plugin
module.exports = {"input":"FormInput_input__1YdeN","label":"FormInput_label__w_xig"};